"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.default = {
    'tools.productAPISearch.name': 'Búsqueda de Productos y Categorías',
    'tools.productAPISearch.description': 'Busca productos y obtiene categorías de productos usando integración con SmartShop API',
};
